import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  toBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(String(reader.result ?? ''));
      reader.onerror = reject;
    });
  }

  extractBase64(dataUrl: string): string {
    const idx = dataUrl.indexOf(',');
    if (idx === -1) return '';
    return dataUrl.slice(idx + 1).trim();
  }

  extractFileNameFromUrl(url: string): string {
    try {
      const pathname = new URL(url).pathname;
      const parts = pathname.split('/').filter(Boolean);
      return parts.length ? decodeURIComponent(parts[parts.length - 1] ?? '') : '';
    } catch {
      const cleaned = url.split('?')[0] ?? '';
      const parts = cleaned.split('/').filter(Boolean);
      return parts.length ? parts[parts.length - 1] ?? '' : '';
    }
  }
}
